export const TWO_DECIMALS_ZERO_AND_POSITIVE = /^\s*(?=.*[0-9])\d*(?:\.\d{1,2})?$/;
export const TWO_DECIMALS_GREATER_THAN_ZERO = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?$/;
export const ONLY_NUMBERS_GREATER_THAN_ZERO = /^(1|[1-9]\d*)$/;
export const ONLY_LETTERS_NUMBERS_DASH_AND_UNDERSCORE = /^[A-Za-z0-9_-]*$/;
